export default __webpack_public_path__ + "static/char-s-62-kr-74615694fae656e8385df49a3d5fc00c.png";